/* eslint-disable padding-line-between-statements */
import React, { useState, useEffect, useCallback } from 'react';
import _ from 'lodash'
import { useLocation, withRouter, useHistory } from 'react-router-dom';
import { useModal, Loader } from '@jutro/components';
import { withViewModelService } from '@xengage/gw-portals-viewmodel-react';
import { Wizard } from '@xengage/gw-portals-wizard-react';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import { useTranslator } from '@jutro/locale';
import { GatewayRenewalService as RenewalService} from 'gw-capability-gateway-policyrenewal'
import { wizardMessages } from 'twia-portals-wizard-components-ui';
import wizardConfig from './config/twia-renewal-residential-wizard-config.json5';
import TWIAWizardHelper from 'producer-engage/src/overrides/modules-react/twia-portals-wizard-components-ui/Wizard/components/util/TWIAWizardHelper';

const TWIAResidentialRenewalWizard = (props) => {
    const translator = useTranslator();
    const [initialSubmission, setInitialSubmission] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const authHeader = _.get(useAuthentication(), 'authHeader');
    const location = useLocation();
    const history = useHistory();
    const { steps, title } = wizardConfig;
    const { viewModelService } = props;
    const { showConfirm } = useModal();
    const {jobNumber} = location?.state;

    useEffect(()=>{
        retrieveSubmission()
    },[authHeader])

    const retrieveSubmission = useCallback(() => {
        if (authHeader) {

            RenewalService.loadRenewal(jobNumber, authHeader).then((response)=>{
                const responseSubmission = viewModelService.create(
                    response, 
                    'pc', 
                    "edge.capabilities.renewal.dto.RenewalDataDTO"
                );
                
                setInitialSubmission(responseSubmission);
                setIsLoading(false);
            })
        }
    }, [authHeader]);

    if (isLoading) {
        return <Loader loaded={!isLoading} />
    }
    
    const getSteps = () => {
        const shouldHideStep = initialSubmission?.value?.baseData?.periodStatus === 'Submitted_Ext';

        return shouldHideStep ? steps.filter(step => step.id === 'PaymentDetailsPage' || step.id === 'PaymentDetails') : steps
    }

    // 2024-12-19 - Debra Frum - US29205 - PE - Renewal - Common - Cancel Quote Pop-up Message 
    //                                          (Handles Commercial and Residential Both)
    // Use the new Cancel action added to the Jutro Wizard package in the Kufri version to customize save and exit handling 
    const onCancelWithProps = wizardObj => {
        const redirectPath = _.get(wizardObj, 'param', `/renewal/${jobNumber}/summary`);
        const wizardSnapshot = wizardObj.wizardSnapshot;
        const wizardData = wizardObj.wizardData;
        const isSaveAction = document.activeElement?.id === 'gw-wizard-save';
        const cancelProps = { wizardSnapshot, wizardData, showConfirm, translator, wizardMessages, setIsLoading, history, redirectPath, authHeader, isSaveAction };

        return TWIAWizardHelper.handleCancel(cancelProps);
    }

    return (
        <Wizard
            initialSteps={getSteps()}
            wizardTitle={title}
            initialData={initialSubmission}
            location={location}
            skipCompletedSteps
            onCancel={onCancelWithProps}
            onPreviousModalProps={{ title: wizardMessages.TWIAWizardModalTitle,
                message: wizardMessages.TWIAWizardModalMessage,
                status: 'warning',
                icon: 'mi-error-outline',
                confirmButtonText: wizardMessages.TWIAWizardModalConfirm,
                cancelButtonText: wizardMessages.TWIAWizardModalCancel,
            }}
        />

    )
}

export default withRouter(withViewModelService(TWIAResidentialRenewalWizard));
